import { useEffect, useRef } from 'react';

const GoogleAd = () => {
  const adRef = useRef(null);

  useEffect(() => {
    let adRendered = false;

    const renderAd = () => {
      try {
        if (window.adsbygoogle && adRef.current && !adRendered) {
          window.adsbygoogle.push({});
          adRendered = true;
        }
      } catch (e) {
        console.error("AdSense error:", e);
      }
    };

    // Try pushing immediately
    renderAd();

    // Retry once after delay in case script wasn't ready
    const retry = setTimeout(() => {
      renderAd();
    }, 1000);

    return () => clearTimeout(retry);
  }, []);

  return (
    <ins
      ref={adRef}
      className="adsbygoogle"
      style={{ display: 'block' }}
      data-ad-client="ca-pub-3045920956719418"
      data-ad-slot="6375338050"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
};

export default GoogleAd;

